import noop from 'lodash/noop';
import TransitionScreenLegacyDialog from '@atlassian/jira-common-components-transition-screen-legacy-dialog/src/index.tsx';
import { timeToRenderTransitionModal } from '@atlassian/jira-common-components-transition-screen-legacy-dialog/src/transition-modal-performance-analytics.tsx';
import { fireIssueTransitionErrorAnalytics as fireErrorAnalytics } from '@atlassian/jira-issue-transition-analytics/src/utils/fire-error-analytics/index.tsx';
import type { IssueTransitionPayloadCallbacks } from '../../common/types.tsx';

export const openLegacyIssueTransitionModal = ({
	issueKey,
	transitionId,
	onDialogSuccess,
	onDialogCancel,
	onDialogError,
	isReopenScenario = false,
	onOpenDialog,
}: {
	issueKey: string;
	transitionId: string;
	isReopenScenario?: boolean;
	onOpenDialog?: () => void;
} & IssueTransitionPayloadCallbacks): void => {
	try {
		timeToRenderTransitionModal.start();
		new TransitionScreenLegacyDialog({
			issueKey,
			transitionId,
		})
			.onDialogSuccess(onDialogSuccess || noop)
			.onDialogCancel(onDialogCancel || noop)
			.onDialogError(onDialogError || noop)
			.show();
		onOpenDialog?.();
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		fireErrorAnalytics({
			meta: {
				id: 'transitionIssueTrigger',
				packageName: 'jiraIssueTransitionTrigger',
				teamName: 'gryffindor',
			},
			error,
			attributes: {
				transitionModalVersion: 'OLD',
				isReopenScenario,
			},
			sendToPrivacyUnsafeSplunk: true,
		});
		throw error;
	}
};
